import React from "react";
import "./Footer.css";
function Footer() {
  return <div className="footer">ddsm</div>;
}

export default Footer;
